import { css, type Theme } from "@emotion/react";

export const BannerContainer = (theme: Theme) => css`
  display: flex;
  min-height: 4rem;
  padding: 1rem;
  gap: 0;
  border-radius: 0.5rem;
  align-items: center;
  justify-content: space-between;
  background-color: ${theme.success.backgroundBase};
`;

export const MobileBanner = css`
  flex-direction: column;
`;

export const BannerContent = (theme: Theme) => css`
  color: ${theme.text.onBackground};
`;
